<template>
  <div :class="computedClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  variant?: 'default' | 'inherit' | 'light' | 'muted'
}>(), {
  variant: 'default',
})

const computedClasses = computed(() => {
  return [
    'uppercase text-xs font-semibold tracking-wider',
    {
      'text-secondary': props.variant === 'default',
      'text-white': props.variant === 'light',
      'text-gray-500': props.variant === 'muted',
    },
  ]
})
</script>
